import React from "react";

import classes from "./Spinner.module.scss";

const spinner = () => {
  return <div className={classes.Loader} />;
};

export default spinner;
